import { navigationService } from "./navigationService";

export const navigatorContainerProps = {
    ref: navigationService.ref,
    documentTitle: {
        formatter: (options, route) => document.title,
    },
}